import { Trans } from "@lingui/react/macro"
import React from "react"

import { useCompanyStats } from "../../../../utils/constants/company-stats"
import {
  AmazonCardIcon,
  Cards,
  CharityPlus,
  Coins,
  GiftCard,
  List,
} from "../../../icon/icon-static-map"
import DropdownHighlight from "../dropdown-highlight"
import DropdownMain from "../dropdown-main"
import NavList from "../nav-list"
import NavListItem from "../nav-list-item"

const CatalogDropdown = () => {
  const COMPANY_STATS = useCompanyStats()
  const payoutOptionCount = COMPANY_STATS.payoutOptions()
  const countriesSupportedCount = COMPANY_STATS.countriesSupported()

  return (
    <>
      <DropdownMain>
        <NavList title={<Trans>categories</Trans>}>
          <NavListItem
            href="/catalog"
            icon={<List color="magenta" size="small" />}
            label={<Trans>Full catalog</Trans>}
            text={
              <Trans>
                Over {payoutOptionCount} options in over{" "}
                {countriesSupportedCount} countries
              </Trans>
            }
          />
          <NavListItem
            href="/products/visa-cards"
            icon={<Cards color="blue" size="small" />}
            label={<Trans>Prepaid cards</Trans>}
            text={<Trans>Send Visas worldwide for free</Trans>}
          />
          <NavListItem
            href="/products/gift-cards"
            icon={<GiftCard color="magenta" size="small" />}
            label={<Trans>Gift cards</Trans>}
            text={
              <Trans>Over {payoutOptionCount} retailers and top brands</Trans>
            }
          />
          <NavListItem
            href="/products/bulk-payouts"
            icon={<Coins color="gold" size="small" />}
            label={<Trans>Monetary payouts</Trans>}
            text={<Trans>Easily send ACH, PayPal, or Venmo in bulk</Trans>}
          />
          <NavListItem
            href="/products/charity-gift-cards"
            icon={<CharityPlus color="orange" size="small" />}
            label={<Trans>Charity</Trans>}
            text={<Trans>Pass along payouts to a worthy cause</Trans>}
          />
        </NavList>
        <NavList title={<Trans>most popular</Trans>}>
          <NavListItem
            href="/catalog/amazon-gift-cards"
            icon={<AmazonCardIcon color="gold" size="small" />}
            label={<Trans>Amazon cards</Trans>}
            text={<Trans>Easier to send and track than buying directly</Trans>}
          />
        </NavList>
      </DropdownMain>
      <DropdownHighlight category="catalog" />
    </>
  )
}

export default CatalogDropdown
